import React from "react";

const CommentAvatar = () => {
  return (
    <div className="shrink-0">
      <img
        src="../../user.png"
        alt=""
        className="w-[44px] h-[44px] rounded-full"
      />
    </div>
  );
};

export default CommentAvatar;
